import { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import axios from "axios";
import { StepTwo } from './StepTwo';
import StepFive from './StepFive';
import StepThree from './StepThree';
import StepOne from './StepOne';
import { StepSix } from './StepSix';
import Header from '../header/Header';

const RegisterNewMember = () => {
  const history = useHistory();
  const [inProgress, setInProgress] = useState(false);
  const [step, setStep] = useState(1);
  const next = () => setStep(prev => prev + 1);
  const prev = () => setStep(prev => prev - 1);

  const [form, setForm] = useState({
    membershipStatus: "仮会員 / PRE-MEMBER",
    membershipCategory: "",
		companyCountrySurvey: "",
    companyStateSurvey: "",
		companyCapitalSurvey: "",
    japaneseEmployeeSurvey: "",
		representativeEmail: "",
		password: "",
		companyNameJapanese: "",
		companyNameEnglish: "",
		companyNumber: "",
		companyLocation: "",
    companyLocationOther: "",
    companyState: "",
		companyAddress: "",
    basicChargeType: "",
    registrationFee: "",
    employeesNumber: "",
    eventsNumber: "",
    foundationFee: 0,
    unitCalculation: 0,
    annualFee: 0,
    admissionFee: 0,
    memberRegistrationFee: 0,
    representativeName: "",
    companyStrengths: "",
    discoverySurvey: ""
	});

  const handleChange = (event: { target: { name: any; value: any; }; }) => {
    const { name, value } = event.target;
    setForm(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const updateUnitCalculation = (value: number) => {
    setForm(prev => ({
      ...prev,
      unitCalculation: value,
    }));
  };

  const updateFees = (fees: {
    foundationFee: number;
    annualFee: number;
    admissionFee: number;
    memberRegistrationFee: number; 
  }) => {
    setForm(prev => ({
      ...prev,
      foundationFee: fees.foundationFee,
      annualFee: fees.annualFee,
      admissionFee: fees.admissionFee,
      memberRegistrationFee: fees.memberRegistrationFee
    }));
  };

  useEffect(() => {
    let determinedCategory = "";

    if (form.companyCountrySurvey === "yes" && form.companyCapitalSurvey === "yes") {
      determinedCategory = "CORPORATE MEMBER/法人会員";
    } else if (
      form.companyCountrySurvey === "yes" &&
      form.companyCapitalSurvey === "no" &&
      form.japaneseEmployeeSurvey === "yes"
    ) {
      determinedCategory = "INDIVIDUAL MEMBER/個人会員";
    } else if (
      form.companyCountrySurvey === "yes" &&
      form.companyCapitalSurvey === "no" &&
      form.japaneseEmployeeSurvey === "no"
    ) {
      determinedCategory = "SUB MEMBER/準会員";
    } else if (
      form.companyCountrySurvey === "no" &&
      form.companyCapitalSurvey === "yes" &&
      form.japaneseEmployeeSurvey === "yes"
    ) {
      determinedCategory = "OVERSEAS MEMBER/在外会員";
    } else if (
      (form.companyCountrySurvey === "no" &&
      form.companyCapitalSurvey === "no") ||
      (form.companyCountrySurvey === "no" &&
      form.japaneseEmployeeSurvey === "no")
    ) {
      determinedCategory = "none";
    }

    // Only update if it changed
    if (determinedCategory && determinedCategory !== form.membershipCategory) {
      setForm(prev => ({
        ...prev,
        membershipCategory: determinedCategory,
      }));
    }
  }, [
    form.companyCountrySurvey,
    form.companyCapitalSurvey,
    form.japaneseEmployeeSurvey,
    form.membershipCategory
  ]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setInProgress(true);

    const companyLocationFinal = form.companyLocation === "Other"
    ? form.companyLocationOther
    : form.companyLocation;

    // helper to add commas and RM
    const formatRM = (n: number) => `RM ${n.toLocaleString('en-MY')}`;

    try {
      const formData = new URLSearchParams();
      formData.append('{{membershipStatus}}', form.membershipStatus);
      formData.append('{{membershipCategory}}', form.membershipCategory);
      formData.append('{{companyNameJapanese}}', form.companyNameJapanese);
      formData.append('{{companyNameEnglish}}', form.companyNameEnglish);
      formData.append('{{companyAddress}}', form.companyAddress);
      formData.append('{{companyLocation}}', companyLocationFinal);
      formData.append('{{companyState}}', form.companyState);
      formData.append('{{companyNumber}}', form.companyNumber);
      formData.append('{{basicChargeType}}', form.basicChargeType);
      formData.append('{{unitCalculation}}', form.unitCalculation.toString());
      formData.append('{{representativeName}}', form.representativeName);
      formData.append('{{representativeEmail}}', form.representativeEmail);
      formData.append('{{admissionFee}}', formatRM(form.memberRegistrationFee));
      formData.append('{{annualFee}}', formatRM(form.annualFee));
      formData.append('{{foundationFee}}', formatRM(form.foundationFee));
      await axios.post(
        'https://l4xdcedk67.execute-api.ap-southeast-1.amazonaws.com/dev/desknetsProxy',
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
        }
      );

      setInProgress(false);
      history.push('/thank-you');
    } catch (err: any) {
      setInProgress(false);
    }
  };

  return (
    <Container>
      <Header />
      <div style={{ padding: 20 }}>
        {step === 1 && <StepOne handleNext={next} />}
        {step === 2 && <StepTwo companyCountrySurvey={form.companyCountrySurvey} companyStateSurvey={form.companyStateSurvey} companyCapitalSurvey={form.companyCapitalSurvey} japaneseEmployeeSurvey={form.japaneseEmployeeSurvey} handleChange={handleChange} handleNext={next} handlePrevious={prev} />}
        {step === 3 && <StepThree membershipCategory={form.membershipCategory} handleNext={next} handlePrevious={prev} />}
        {/* {step === 4 && <StepFour companyStrengths={form.companyStrengths} discoverySurvey={form.discoverySurvey} handleChange={handleChange} handleNext={next} handlePrevious={prev} />} */}
        {step === 4 && <StepFive representativeEmail={form.representativeEmail} companyNameJapanese={form.companyNameJapanese} companyNameEnglish={form.companyNameEnglish} companyNumber={form.companyNumber} companyLocation={form.companyLocation} companyLocationOther={form.companyLocationOther} companyState={form.companyState} companyAddress={form.companyAddress} handleChange={handleChange} handleNext={next} handlePrevious={prev} />}
        {step === 5 && <StepSix updateUnitCalculation={updateUnitCalculation} setFees={updateFees} inProgress={inProgress} basicChargeType={form.basicChargeType} stateSelection={form.companyStateSurvey} registrationFee={form.registrationFee} employeesNumber={form.employeesNumber} eventsNumber={form.eventsNumber} foundationFee={form.foundationFee} unitCalculation={form.unitCalculation} annualFee={form.annualFee} admissionFee={form.admissionFee} membershipCategory={form.membershipCategory} representativeName={form.representativeName} handleChange={handleChange} handleSubmit={handleSubmit} handlePrevious={prev} />}
      </div>
    </Container>
  )
}

export default RegisterNewMember;